import { useState, useEffect } from 'react';
import './Donate.css';
import PropTypes from 'prop-types';
import { PayDisclaimer } from '../Donate/PayDisclaimer';

export function PaymentSummary({ setFinalAmount, finalAmount, setPaymentOption }) {
  const [isFull, setIsFull] = useState(true);

  useEffect(() => {
    console.log();
  }, []) //notice the empty array here

  const myPaymentChangeHandler = (e) => {
    setIsFull(!isFull);
    const target = e.currentTarget;
    if (target) {
      const amountWithCurrency = target.value;
      setFinalAmount(amountWithCurrency);
      if (isFull) {
        setPaymentOption("Full");
      } else {
        setPaymentOption("Split");
      }

    }
  }

  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <h2>Payment Summary</h2>
          <div className="form-group">
            <div className="radio">
              <label className="control-label">
                <input type="radio" name="paymentSchedule" id="onetime" value={finalAmount} onChange={myPaymentChangeHandler} checked={isFull} />One time payment of <strong>${finalAmount}</strong>
              </label>
            </div>
            {/* <div className="radio">
                  <label className="control-label">
                      <input type="radio" name="paymentSchedule" id="reoccurring" value="0" onChange={myPaymentChangeHandler} checked={!isFull} />
                      Some other option
                  </label>
              </div> */}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <PayDisclaimer />
        </div>
      </div>
    </div>
  );
}

PaymentSummary.propTypes = {
  setFinalAmount: PropTypes.any,
  finalAmount: PropTypes.string,
  setPaymentOption: PropTypes.any
};